import { setSentryUser } from '@ui/analytics'
import { useEffect } from 'react'
import { useUserId } from './useUserId'

/**
 * Keeps the Sentry user in sync with the uid (the `uid` query param, else the `x-uid`
 * cookie). The last known uid is kept when a later page carries neither, so errors
 * after navigation stay attributed.
 */
export const useSentryUser = () => {
  const userId = useUserId()

  useEffect(() => {
    setSentryUser(userId)
  }, [userId])
}
